<template>
    <v-dialog v-model="IsOpenSpreadsheetDialog" max-width="1200px">
        <v-card elevation="0">
            <v-card-title primary-title>
                <v-row dense>
                    <v-col cols="12" md="6">
                        <div
                            v-if="$vuetify.breakpoint.smAndDown"
                            class="primary--text text-overline ml-2 text-center"
                        >
                            Operaciones sobre BD
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h4
                                ml-2
                                text-capitalize
                            "
                        >
                            <v-icon large left> mdi-database-edit </v-icon>
                            Operaciones sobre BD
                        </div>
                    </v-col>
                    <v-col v-if="tab == 1" cols="12" md="6">
                        <div
                            :class="
                                $vuetify.breakpoint.smAndDown
                                    ? 'd-flex justify-center'
                                    : 'd-flex justify-end'
                            "
                        >
                            <div class="mr-2">
                                <v-btn
                                    @click="downloadTemplate()"
                                    class="vcard-text-sm"
                                    small
                                    :disabled="isExporting"
                                    outlined
                                    dark
                                    color="orange accent-3"
                                >
                                    {{
                                        $vuetify.breakpoint.smAndDown
                                            ? ''
                                            : 'Descargar plantilla'
                                    }}
                                    <v-icon rigth>mdi-arrow-down</v-icon>
                                </v-btn>
                            </div>
                            <div>
                                <v-btn
                                    @click="files = []"
                                    class="vcard-text-sm"
                                    small
                                    outlined
                                    :disabled="isExporting"
                                    dark
                                    color="red darken-2"
                                >
                                    {{
                                        $vuetify.breakpoint.smAndDown
                                            ? ''
                                            : 'borrar'
                                    }}
                                    <v-icon rigth>mdi-delete</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>

            <!-- <v-divider class="test"></v-divider> -->

            <v-card-text class="pa-0">
                <v-tabs
                    fixed-tabs
                    :vertical="!$vuetify.breakpoint.smAndDown"
                    center-active
                >
                    <v-tabs-slider v-if="false"></v-tabs-slider>
                    <v-tab :disabled="isExporting" @click="tab = 0">
                        <v-icon color="primary" left>
                            mdi-database-export-outline
                        </v-icon>
                        <div class="overline primary--text">Exportación</div>
                    </v-tab>
                    <v-tab :disabled="isExporting" @click="tab = 1">
                        <v-icon color="primary" left>
                            mdi-database-import-outline
                        </v-icon>
                        <div class="overline primary--text">Importación</div>
                    </v-tab>
                    <v-tab-item>
                        <SpreadSheetDialog />
                    </v-tab-item>
                    <v-tab-item>
                        <UploadForm
                            action="Subiendo"
                            message="subir una base de datos de nuevos clientes"
                            :multiple="true"
                        />
                    </v-tab-item>
                </v-tabs>
            </v-card-text>

            <v-card-actions class="justify-end">
                <v-btn
                    text
                    :disabled="isExporting"
                    color="red"
                    @click="close()"
                >
                    Cerrar
                </v-btn>
                <v-btn
                    :disabled="
                        (spreadSheetHeaders.length == 0 && tab == 0) ||
                        (files.length == 0 && tab == 1) ||
                        isExporting
                    "
                    color="primary"
                    @click="finalizar"
                >
                    {{ tab == 0 ? 'exportar' : 'importar' }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import SpreadSheetDialog from '@/components/ComercialTeletrabajo/SpreadsheetDialog/SpreadsheetDialog.vue';
import UploadForm from '@/components/UploadForm/UploadForm.vue';
import { mapState } from 'vuex';
import * as customersTemplate from '@/util/customersTemplate.json';

export default {
    name: 'SpreadSheetDialogOps',
    data: () => ({
        tab: 0,
    }),
    components: {
        SpreadSheetDialog,
        UploadForm,
    },
    computed: {
        IsOpenSpreadsheetDialog: {
            get() {
                return this.$store.state.teletrabajo.IsOpenSpreadsheetDialog;
            },
            set(val) {
                this.$store.commit('teletrabajo/IsOpenSpreadsheetDialog', val);
            },
        },
        spreadSheetHeaders: {
            get() {
                return this.$store.state.teletrabajo.spreadSheetHeaders;
            },
            set(val) {
                this.$store.commit('teletrabajo/spreadSheetHeaders', val);
            },
        },
        files: {
            get() {
                return this.$store.state.gerencia.files;
            },
            set(val) {
                this.$store.commit('gerencia/files', val);
            },
        },
        ...mapState('util', {
            isExporting: (state) => state.isExporting,
        }),
    },
    mounted() {
        if (document.querySelector('.v-slide-group__prev'))
            document.querySelector('.v-slide-group__prev').remove();
    },
    methods: {
        downloadTemplate() {
            this.$store.dispatch(
                'gerencia/download_template_from_json',
                customersTemplate.default
            );
        },
        finalizar() {
            if (this.tab == 0) {
                this.spreadSheetHeaders = this.spreadSheetHeaders.map(
                    (element) => {
                        let snakeCase = element
                            .replace(/([A-Z])/g, '_$1')
                            .toLowerCase();

                        return snakeCase.slice(1).split(' ').join('');
                    }
                );
                this.$store.dispatch('teletrabajo/exportDB').then(() => {
                    this.spreadSheetHeaders = {};
                });
            } else if (this.tab == 1) {
                let params = {
                    task_to_do: 'import_clientes_xlsx',
                };
                this.$store.dispatch(
                    'gerencia/importFiles',
                    params
                    // 'import_clientes_xlsx'
                );
            }
        },
        // download() {
        //     this.spreadSheetHeaders = this.spreadSheetHeaders.map((element) => {
        //         let snakeCase = element
        //             .replace(/([A-Z])/g, '_$1')
        //             .toLowerCase();

        //         return snakeCase.slice(1).split(' ').join('');
        //     });
        //     this.$store.dispatch('teletrabajo/exportDB').then(() => {
        //         this.spreadSheetHeaders = {};
        //     });
        // },
        close() {
            this.$store.commit('teletrabajo/IsOpenSpreadsheetDialog', false);
        },
    },
};
</script>

<style scoped>
</style>